// price-visibility.js —— 确保缺货时仍显示价格和售罄，不影响轮播等组件
(function(){
  var ROOT = document.getElementById('main-product-section') || document;

  var PRICE_SELECTORS = [
    '.main-product__prices-container',
    '.product-prices',
    '.product-prices__price'
  ];

  function $all(sel, scope){ return Array.prototype.slice.call((scope||document).querySelectorAll(sel)); }

  function unhide(scope){
    var ctx = scope || ROOT;
    PRICE_SELECTORS.forEach(function(sel){
      $all(sel, ctx).forEach(function(el){
        if (el.hasAttribute && el.hasAttribute('hidden')) el.removeAttribute('hidden');
        if (el.classList) el.classList.remove('hidden','is-hidden','visually-hidden','u-hidden');
        if (el.style && (el.style.display === 'none' || el.style.visibility === 'hidden' || el.style.opacity === '0')){
          el.style.display = ''; el.style.visibility = ''; el.style.opacity = '';
        }
      });
    });
  }

  // 初始兜底：多次尝试解除隐藏
  var ticks = 0;
  var t = setInterval(function(){
    unhide();
    if (++ticks > 20) clearInterval(t);
  }, 300);

  // 观察价格节点的属性变化（防止 JS 再次隐藏）
  function observeNode(node){
    try{
      var mo = new MutationObserver(function(muts){
        var need = false;
        muts.forEach(function(m){
          if (m.type === 'attributes') need = true;
        });
        if (need) unhide(node);
      });
      mo.observe(node, { attributes:true, attributeFilter:['hidden','class','style'] });
    }catch(e){}
  }
  PRICE_SELECTORS.forEach(function(sel){ $all(sel, ROOT).forEach(observeNode); });

  // 监控新增的价格节点
  var moRoot = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length){
        Array.prototype.forEach.call(m.addedNodes, function(n){
          if (n.querySelector){
            var priceNode = n.matches && (PRICE_SELECTORS.some(function(s){ return n.matches(s); })) ? n : n.querySelector(PRICE_SELECTORS.join(','));
            if (priceNode){ unhide(priceNode); observeNode(priceNode); }
          }
        });
      }
    });
  });
  moRoot.observe(ROOT, { subtree:true, childList:true });
})();
